import FiltersBox from "PFApp/components/filters/filters_box";
import { fetchOptions } from "PFCore/services/export_booking";
import { Filter, Filters as FiltersType } from "PFTypes";
import React, { JSX, MutableRefObject } from "react";

import css from "./filters.module.scss";

interface FiltersProps {
  loading: boolean;
  filters: FiltersType;
  onFilterChange: (filter: Filter, value: string, options?: { clear: boolean }) => void;
  portalRef?: MutableRefObject<HTMLDivElement | null>;
}

export const Filters = ({ loading, filters, onFilterChange, portalRef }: FiltersProps): JSX.Element => (
  <FiltersBox
    isLoading={loading}
    meta={{ filters }}
    handleFilterChange={onFilterChange}
    filtersAreClear
    withTitle={false}
    allowToClose={false}
    classes={{
      root: css.filtersRoot,
      header: css.filtersHeader,
      list: css.filtersList
    }}
    fetchOptions={fetchOptions}
    portalRef={portalRef}
  />
);
